var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.42412L0.5 3.70984L0.5 0.5L13.5 0.5L13.5 3.70984L7 7.42412Z",
    fill: "#0097A9",
    stroke: "#0097A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationIndicator);
export default __webpack_public_path__ + "static/media/annotation-indicator.f26c9948ac924a70cd3544da9257743d.svg";
export { ForwardRef as ReactComponent };